/**
 * Quiz state helpers shared between host and participant views.
 */

/**
 * Returns true when the current question's answer should be revealed to
 * everyone — either because the question timer has expired, or because all
 * participants have submitted an answer.
 *
 * @param {Object} session - session document from Firestore
 * @param {Object} quiz - quiz document from Firestore
 * @returns {boolean}
 */
export function isQuestionRevealed(session, quiz) {
  if (!session || !quiz) return false;
  const idx = session.currentQuestionIndex;
  const q = quiz.questions?.[idx];
  if (!q || !session.questionStartTime) return false;

  // 1) Timer expired
  const timeLimit = q.timeLimit || 30;
  const elapsed =
    (Date.now() - new Date(session.questionStartTime).getTime()) / 1000;
  if (elapsed >= timeLimit) return true;

  // 2) All participants have answered
  const participants = Object.values(session.participants || {});
  if (participants.length === 0) return false;
  return participants.every((p) => p.answers?.[q.id] !== undefined);
}
